import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { afterItems, beforeItems } from '../../data/lists';
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-89" data-mp="26mmf6vc25lp0">
      <div className="mx-auto max-w-5xl" data-id="element-90" data-mp="22lkbo2b3ynh8">
        <SectionHeading title={<>
              From scattered reflexology information… to a <em className="text-cta" data-id="element-92" data-mp="2z8xkukeiucso">clear 21-day practice system</em>
            </>} data-id="element-91" data-mp="22mlvav66wiak" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-93" data-mp="2ua4a2zqmczw7">
          <div className="rounded-3xl border-2 border-rose/20 bg-paper p-5 sm:p-7" data-id="element-94" data-mp="2q90ri5h6spra">
            <p className="inline-flex items-center gap-2 rounded-full bg-rose px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-95" data-mp="2la7e0d1wgyr4">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-96" data-mp="1esu1nymrme9l" /> Before
            </p>
            <ul className="mt-5 space-y-3" data-id="element-97" data-mp="19uslblgq4t1t">
              {beforeItems.map(t => <li key={t} className="flex gap-3 text-base leading-relaxed text-ink/85" data-id="element-98" data-mp="175vtqpsyjjiu">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-rose/10 text-rose" data-id="element-99" data-mp="1c35pen6xwrf4">
                    <XIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-100" data-mp="y6sdrup37k8k" />
                  </span>
                  {t}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-forest p-5 text-cream sm:p-7" data-id="element-101" data-mp="od1owop1t7sc">
            <p className="inline-flex items-center gap-2 rounded-full bg-cta px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-102" data-mp="t75vh6uejdsw">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-103" data-mp="jfia9nofuszv" /> After · With the method
            </p>
            <ul className="mt-5 space-y-3" data-id="element-104" data-mp="5fh0fiq74b89">
              {afterItems.map(t => <li key={t} className="flex gap-3 text-base leading-relaxed" data-id="element-105" data-mp="aetxewas6yok">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-106" data-mp="agxyz7l7jllo">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-107" data-mp="27dstuu4zezsu" />
                  </span>
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-108" data-mp="1ydnosqn9gdhu">
          <p className="text-lg text-muted" data-id="element-109" data-mp="2v3513ogr0xsi">Instead of asking yourself “What should I do today?”</p>
          <p className="mt-2 text-lg text-ink" data-id="element-110" data-mp="2r1jsifb8z5o4">You'll have a system telling you:</p>
          <p className="mt-2 font-serif text-4xl font-extrabold italic text-forest" data-id="element-111" data-mp="2qzfdb17wek8j">“Start here.”</p>
        </div>

        <div className="mt-10" data-id="element-112" data-mp="2h3cfu8nzr9rx">
          <CTAButton label="Yes! I want my 21-day reflexology system" note="One-time payment of $27 · Lifetime access" data-id="element-113" data-mp="2h45boeleweva" />
        </div>
      </div>
    </section>;
}